import React, { useState, useMemo, useEffect } from 'react';
import * as msal from '@azure/msal-browser';
import FormAuthButton from './FormAuthButton';

const FormAuthAzure = ({
  disabled,
  error,
  field,
  onChange,
}) => {
  const [authenticating, setAuthenticating] = useState(false);
  const [authenticated, setAuthenticated] = useState(false);
  const [authenticationError, setAuthenticationError] = useState(false);

  const msalConfig = {
    auth: {
      clientId: field.clientId,
      authority: field.authority,
      redirectUri: `${window.location.origin}/auth.html`,
      knownAuthorities: [field.authorityDomain],
    },
    cache: {
      cacheLocation: 'localStorage',
      storeAuthStateInCookie: false,
    },
  };

  const loginRequest = { scopes: field.scopes };
  if (field.domainHint) {
    loginRequest.extraQueryParameters = { domain_hint: field.domainHint };
  }

  const msalClient = useMemo(() => new msal.PublicClientApplication(msalConfig), []);

  useEffect(() => {
    const existingAccounts = msalClient.getAllAccounts();
    if (existingAccounts.length) {
      setAuthenticating(true);
      const silentRequest = {
        scopes: field.tokenScopes || field.scopes,
        account: existingAccounts[0],
      };
      msalClient.acquireTokenSilent(silentRequest)
        .then((refreshResponse) => {
          setAuthenticating(false);
          setAuthenticated(true);
          onChange(refreshResponse.accessToken);
        }).catch((e) => {
          window.console.log(e);
          setAuthenticating(false);
          setAuthenticated(false);
        });
    }
  }, []);

  const auth = () => {
    setAuthenticating(true);
    msalClient.loginPopup(loginRequest)
      .then((loginResponse) => {
        onChange(loginResponse.accessToken);
        setAuthenticating(false);
        setAuthenticated(true);
      }).catch((e) => {
        window.console.log(e);
        setAuthenticating(false);
        setAuthenticated(false);
        setAuthenticationError(true);
      });
  };

  return (
    <FormAuthButton
      field={field}
      disabled={disabled || authenticating || authenticated}
      auth={auth}
      authenticating={authenticating}
      authenticated={authenticated}
      authenticationError={authenticationError}
      validationError={error}
    />
  );
};

export default FormAuthAzure;
